var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NewLatest'),_c('ListInterShip'),_c('ServiceTOP'),_c('JobInternTOP'),_c('InternTOP'),_c('SchoolTop'),_c('Videos')],1)}
var staticRenderFns = []

export { render, staticRenderFns }